import React from "react";
import Partners from "./Partners/Partners";
import Contact from "./Contact/Contact";
import {Background, BackgroundWrapper, InfoSection} from "./Info.styles";

const Info = () => {
    return (<InfoSection>
        <BackgroundWrapper>
            <Background>
                <Partners/>
                <Contact/>
            </Background>
        </BackgroundWrapper>
    </InfoSection>);
};

export default Info;
